export interface Sort {
    field: string;
    sortString: SortString;
}

export enum SortString {
    ASC = "asc",
    DESC = "desc"
}
